module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MC-dfddd32fb8fb0fc7161731726ce03dc0.png";